import { fetchAuthSession } from 'aws-amplify/auth';

export const getBearerToken = async (): Promise<string | null> => {
    try {
        const session = await fetchAuthSession();
        return session.tokens?.idToken?.toString() ?? null;
    } catch {
        return null;
    }
};
